import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Grid, Box, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import {
  ModernLiquidTable,
  LiquidIconButton,
} from "../../../components/modern-table";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import {
  getAllAssociates,
  getAssociatesByBranch,
} from "../../../api/associate";
import exportToExcel from "../../../utils/exportToExcel";

export default function MemberListPage() {
  const location = useLocation();
  const { userType, branch } = useSelector(({ auth }) => auth.user);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const br = userType === 0 ? undefined : branch;

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = br
        ? await getAssociatesByBranch(br)
        : await getAllAssociates();
      if (data) {
        setRows(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [br]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData, location.search]);

  const columns = [
    {
      field: "_rowNumber",
      title: "No",
      width: 50,
      render: (rowData) => <p>{rowData._rowNumber}</p>,
    },
    { field: "fullname", title: "Nama", width: 200 },
    {
      field: "associateId",
      title: "No Pendaftaran",
    },
    {
      field: "branch",
      title: "Cawangan Gema",
      render: (rowData) => {
        if (rowData.branch) {
          return rowData.branch.replace("_", " ");
        }
        return null;
      },
    },
    {
      field: "email",
      title: "E-mel",
    },
    {
      field: "phone",
      title: "No Tel",
    },
    {
      field: "actions",
      title: "Tindakan",
      width: 100,
      render: (rowData) => (
        <Tooltip title="Edit">
          <Link to={`/associate/edit?id=${rowData.id}`}>
            <LiquidIconButton size="small">
              <EditIcon />
            </LiquidIconButton>
          </Link>
        </Tooltip>
      ),
    },
  ];

  const handleExport = (columns, data) => {
    const st = data.map((associate) => {
      return {
        No_Ahli: associate.associateId,
        Cawangan: associate.branch,
        Nama: associate.fullname,
        Emel: associate.email,
        Facebook: associate.fbProfile,
        Instagram: associate.iGProfile,
        No_IC: associate.nationalId,
        No_Tel: associate.phone,
        Tiktok: associate.tikTokProfile,
      };
    });
    exportToExcel(st);
  };

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background:
                  "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
                borderRadius: "12px",
                backdropFilter: "blur(10px)",
              }}
            >
              <span className="kt-section__sub">
                Senarai di bawah adalah rakan gema yang telah mendaftar melalui
                sistem sigma.
              </span>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={columns}
              data={rows}
              title={`Bilangan rakan: ${rows.length}`}
              loading={loading}
              onRefresh={fetchData}
              exportFunction={handleExport}
              emptyStateMessage="Tiada rakan gema berdaftar"
              options={{
                selection: false,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
